module.exports = __webpack_public_path__ + "img/PL08682.e27d2e32.png";